// extracted by mini-css-extract-plugin
module.exports = {"primaryDefault":"#db1238","secondaryDefault":"#1d2a39","iconSecondaryDefault":"#db1238","iconPrimaryDefault":"#fff","fontDefault":"#fff"};